import React from 'react'
import {Table} from 'react-bootstrap'
import {t} from '../../helpers/translate'

class ExtensionComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  renderExtensions () {
    return (
      <tbody>
      { this.props.extensions.map(
        (extension, index) => {
          return (
            <tr key={index}>
              {this.renderTableCell(extension.start_date)}
              {this.renderTableCell(extension.end_date)}
              {/*this.renderTableCell(extension.status)*/}
            </tr>
          )
        })
        }
      </tbody>
    )
  }

  renderTableCell (value) {
    return <td>{value}</td>
  }

  render() {
    const tableHead = [t('Start Date'), t('End Date')];

    return <div>
      {this.props.extensions.length > 0 &&
        <Table striped condensed hover id='noteTable'>
          <thead>
            <tr>
            {tableHead.map((header, index) => <th key={index}>{header}</th>)}
            </tr>
          </thead>
          {this.renderExtensions()}
        </Table>
      }
    </div>
  }
}
ExtensionComponent.displayName = 'ExtensionComponent';
export default ExtensionComponent;


// WEBPACK FOOTER //
// ./src/components/common/ExtensionComponent.js